export default __webpack_public_path__ + "static/media/LinkedIn.d1da3c46.svg";